// src/components/store/sections/blog-posts/BlogV12ClaychronicleCoralFlame.tsx
"use client";

import React from "react";
import DynamicBlogVariant from "./DynamicBlogVariant";

export default function BlogV12ClaychronicleCoralFlame(props: any) {
  return (
    <DynamicBlogVariant
      variantNumber={12}
      archKey="clay_chronicle"
      archLabel="3D Clay Chronicle Cards"
      palName="CoralFlame"
      grad="from-orange-500 via-rose-500 to-pink-700"
      lightBg="bg-orange-50"
      textCol="text-orange-700"
      borderCol="border-orange-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f97316"
      {...props}
    />
  );
}
